import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row } from "reactstrap";
import { FaMinus, FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import { checkFinalPrice } from "../checkFinalPrice";
import {
  incrementAddonQuantity,
  decrementAddonQuantity,
} from "store/actions/orderActions";

const AddOnCounter = ({ orderItemID, addon }) => {
  const dispatch = useDispatch();
  const { updatedOrder } = useSelector((state) => state.orders);
  const { restaurantsDetail } = useSelector((state) => state.restaurant);
  const bgColor = restaurantsDetail?.adminColor;

  const itemPrice = parseFloat(addon?.price) || 0;

  const simulatedFinal = checkFinalPrice({
    cartItems: updatedOrder.order,
    restaurant: restaurantsDetail,
    itemPrice: itemPrice,
  });
  const isDisabled = simulatedFinal >= 10000;

  const handleIncrement = () => {
    if (isDisabled) {
      return;
    }

    const simulatedValue = checkFinalPrice({
      cartItems: updatedOrder.order,
      restaurant: restaurantsDetail,
      itemPrice: itemPrice * 2,
    });

    if (simulatedValue >= 10000) {
      toast.warning("Total amount limit per order is 10,000.");
    }

    dispatch(
      incrementAddonQuantity({
        orderItemID,
        addonID: addon.id,
      })
    );
  };

  return (
    <Row className="m-0 w-100 justify-content-between">
      <div
        onClick={() => {
          const quantity = addon?.quantity || 1;
          if (quantity >= 0) {
            dispatch(
              decrementAddonQuantity({
                orderItemID,
                addonID: addon.id,
              })
            );
          }
        }}
        style={{
          marginRight: "0px",
          marginLeft: "0px",
        }}
        className="top_cards__operators d-flex justify-content-center align-items-center"
      >
        {" "}
        <FaMinus
          style={{
            color: "rgb(82, 95, 127)",
          }}
        />{" "}
      </div>
      <div className="top_cards__number">{addon?.quantity}</div>
      <div
        onClick={() => handleIncrement(addon?.orderItemID, addon?.size)}
        style={{
          border: `2px solid ${isDisabled ? "rgb(170, 170, 172)" : bgColor}`,
          color: bgColor,
          pointerEvents: isDisabled ? "none" : "auto",
          marginLeft: "0px",
          marginRight: "0px",
        }}
        className="top_cards__operators-active d-flex justify-content-center align-items-center"
      >
        <FaPlus
          style={{
            color: isDisabled ? "rgb(170, 170, 172)" : bgColor,
          }}
        />
      </div>
    </Row>
  );
};

export default AddOnCounter;
